










import { listFactory } from '@/main/pages';

import Select from '../components/Select.vue';
import { NAME } from './constants';
import { store } from './store/list';
import { listMutations } from './store/types';

export default listFactory(NAME, store).extend({
	components: {
		PartnerSelect: Select,
	},
	computed: {
		mutationsMappers() {
			return {
				zakaznik: `${this.storeUri}/${listMutations.ZAKAZNIK_ID_FILTER_SELECT_MAPPER}`,
			};
		},
	},
});
